<template>
  <output-dialog
    :pages="pages"
    filename="detail.pdf"
    orientation="portrait"
    ref="printDlg"
    title="輸入諸掛費用明細(合計表)"
  >
    <template slot-scope="{page}">
      <div class="page">
        <div style="text-align:right;">
          発行日:
          &nbsp;
          &nbsp;
          &nbsp;
          2018.01.26
          &nbsp;
          &nbsp;
          &nbsp;
          NO.
          &nbsp;
          &nbsp;
          18-00720
        </div>
        <h1>輸入諸掛費用明細(合計表)</h1>
        <table>
          <tr>
            <td>D/O番号</td>
            <td>8S66X</td>
            <td colspan="2">シャープトレーディング（株）</td>
          </tr>
          <tr>
            <td>輸出者</td>
            <td>ＳＡＴＬ</td>
            <td>(外線)TEL</td>
            <td>０７２－２８２－１９０３</td>
          </tr>
          <tr>
            <td>建値条件</td>
            <td>FOB</td>
            <td>(外線)FAX</td>
            <td>０７２－２２２－５７２７</td>
          </tr>
          <tr>
            <td>B/L No.(MAWB)</td>
            <td>920571043</td>
            <td>(内線)TEL</td>
            <td></td>
          </tr>
          <tr>
            <td>B/L No.(HAWB)</td>
            <td></td>
            <td>(内線)FAX</td>
            <td></td>
          </tr>
          <tr>
            <td>積出日/積出港</td>
            <td>2018.01.15 ＬＡＥＭ ＣＨＡＢＡＮＧ</td>
            <td>営業担当者</td>
            <td>石川 孝至</td>
          </tr>
          <tr>
            <td>本船入港日/到着港</td>
            <td>2018.01.24 東京港</td>
            <td>通関担当者</td>
            <td>内需営業部 （ＳＪＬＬ）</td>
          </tr>
        </table>

        <div class="summary">
          <table>
            <tr>
              <td>商品代金</td>
              <td>外貨名</td>
              <td style="text-align:right">外貨額</td>
              <td style="text-align:right">レート</td>
              <td style="text-align:right">円</td>
            </tr>
            <tr>
              <td>外貨額/レート/円金額</td>
              <td>(US$)</td>
              <td style="text-align:right">69,928.92</td>
              <td style="text-align:right">114.0400</td>
              <td style="text-align:right">7,974,694</td>
            </tr>
            <tr>
              <td>海上航空運賃</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">112,768</td>
            </tr>
            <tr>
              <td>国内運賃</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">33,000</td>
            </tr>
            <tr>
              <td>保険費</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">4,448</td>
            </tr>
            <tr>
              <td>搬出手数料</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">0</td>
            </tr>
            <tr>
              <td>Ｃ．Ｃ．Ｆｅｅ</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">0</td>
            </tr>
            <tr>
              <td>上屋施設利用料(AIR)</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">0</td>
            </tr>
            <tr>
              <td>保管料(SEA)</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">0</td>
            </tr>
            <tr>
              <td>取扱料</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">10,000</td>
            </tr>
            <tr>
              <td>通関料</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">5,000</td>
            </tr>
            <tr>
              <td>臨時開庁料</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">0</td>
            </tr>
            <tr>
              <td>緊急作業料</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">0</td>
            </tr>
            <tr>
              <td>デバン料</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">15,000</td>
            </tr>

            <tr>
              <td>廃棄物処理費用</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">640</td>
            </tr>
            <tr>
              <td>その他諸掛費用※</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">26</td>
            </tr>
            <tr>
              <td>予備項目１</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">0</td>
            </tr>
            <tr>
              <td>予備項目２</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">5,000</td>
            </tr>
            <tr>
              <td>STCコミッション</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right">99,116</td>
            </tr>
            <tr>
              <td colspan="5">※その他諸掛費用は、関税・ＡＩＲ保管料等の合計額を３ケ月の輸入件数で按分した金額を表示しています。</td>
            </tr>
            <tr style="border-bottom:0px;">
              <td style="font-size:18px;font-weight:bold;">合計</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align:right;font-size:18px;font-weight:bold;">8,259,692</td>
            </tr>
          </table>
        </div>
        <table>
          <tr>
            <td style="width:120px;">保管料(SEA)コメント</td>
            <td></td>
          </tr>
        </table>

        <div class="footer">PAGE: 1 / 1</div>
      </div>
    </template>
  </output-dialog>
</template>
<script>
export default {
  data() {
    return {
      pages: [{}]
    }
  },
  computed: {},
  methods: {
    popup(pages) {
      this.$refs.printDlg.show = true
      this.pages = pages
    }
  }
}
</script>

<style scoped>
.page {
  padding: 30px 30px;
}
h1 {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 4px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}
table td {
  padding: 2px;
  vertical-align: top;
}
.summary {
  border: 2px solid #333;
  padding: 0px 0px 0px 15px;
}
.summary tr {
  border-bottom: 1px dashed #333;
}
.bill tr {
  border-bottom: 1px solid #333;
}
.bill .header {
  font-weight: bold;
}
.footer {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
  bottom: 25px;
}
</style>